import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

import { create } from '@api/v4/resources/metadata_conversions';
import { update } from '@api/v4/metadata_conversions';

import './styles/metadata_conversions_form';

const Form = ({
  resourceType,
  resourceKey,
  refreshData,
  editableKey,
  setEditableKey,
  setShowForm,
  selectedItem,
}) => {
  const [convert_to_tags, setConvertToTags] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [metadata_term, setMetaTerm] = useState('');
  const [key_term, setKeyTerm] = useState('');
  const [error, setError] = useState(null);

  const submit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    if (editableKey) {
      update({
        id: editableKey,
        metadata_term,
        key_term,
        convert_to_tags: !!convert_to_tags,
      }).then(() => {
        refreshData();
        setEditableKey(null);
        setShowForm(false);
        Notify.create({ type: "success", key_term: "Mapping Updated!" });
      }).catch(({ errors }) => {
        setError(errors);
      }).finally(() => {
        setSubmitting(false);
      });
    } else {
      create({
        resourceType,
        resourceKey,
        metadata_term,
        key_term,
        convert_to_tags: !!convert_to_tags,
      }).then(() => {
        refreshData();
        setEditableKey(null);
        setShowForm(false);
        Notify.create({ type: "success", key_term: "Mapping Created!" });
      }).catch(({ errors }) => {
        setError(errors);
      }).finally(() => {
        setSubmitting(false);
      });
    }
  };

  const closeForm = () => {
    setEditableKey(null);
    setShowForm(false);
  };

  useEffect(() => {
    if (selectedItem) {
      setMetaTerm(selectedItem.metadata_term);
      setKeyTerm(selectedItem.key_term);
    }
  }, [selectedItem]);

  const metaFieldSuggestions = ["width", "filter", "height", "bit_depth", "file_size", "file_type", "mime_type", "color_type", "image_size", "interlace", "image_width", "megapixels", "colorspace", "compression", "image_height", "frame_count", "aspect_ratio", "average_color", "file_access_date", "file_modify_date", "file_type_extension", "has_clipping_path", "date_file_modified", "file_inode_change_date", "keywords"];

  return (
    <>
      <div className="metadata_conversions--cancel-edit" onClick={closeForm} onKeyPress={closeForm} role="button" tabIndex={0}>
        <span className="bff-left-arrow" />
        <span>{t('Back')}</span>
      </div>
      <form
        className="metadata_conversions--form"
        onSubmit={submit}
      >
        <label
          className="bf-label"
          htmlFor="select-metadata-conversion-target"
        >
          {t('Convert metadata into')}
        </label>
        <Select
          name="select-metadata-conversion-target"
          value={convert_to_tags}
          options={[
            { value: false,
              label: t("Custom Fields") },
            { value: true,
              label: t("Tags") }
          ]}
          clearable={false}
          searchable={false}
          onChange={(option) => setConvertToTags(option.value)}
        />

        <div>
          <label
            className="bf-label"
            htmlFor="mapping-metadata_term"
          >
            {t('Select embedded metadata field')}
            <input
              name="mapping-metadata_term"
              id="mapping-metadata_term"
              className="bf-input"
              type="text"
              list="suggestions"
              value={metadata_term}
              onChange={({ target }) => setMetaTerm(target.value)}
              disabled={submitting}
              required
            />
            <datalist id="suggestions">
              { metaFieldSuggestions.map((field) => <option value={field} key={field} />)}
            </datalist>
          </label>
        </div>

        { !convert_to_tags
          && (
            <div>
              <label
                className="bf-label"
                htmlFor="mapping-key_term"
              >
                {t('Name your new custom field key')}
                <input
                  name="mapping-key_term"
                  id="mapping-key_term"
                  className="bf-input"
                  type="text"
                  value={key_term}
                  onChange={({ target }) => setKeyTerm(target.value)}
                  disabled={submitting}
                  required
                />
              </label>
            </div>
          )
        }

        <div className={`metadata_conversions--button-container ${error && 'has-error'}`}>
          {!!error && (
            <p className="error-message">{error}</p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="button primary md"
          >
            {editableKey ? t("Update Conversion") : t("Create Conversion")}
          </button>
        </div>
      </form>
    </>
  );
};

Form.propTypes = {
  resourceKey: PropTypes.string.isRequired,
  refreshData: PropTypes.func,
  resourceType: PropTypes.string,
  editableKey: PropTypes.string,
  setEditableKey: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.string,
    metadata_term: PropTypes.string,
    key_term: PropTypes.string,
  })
};

Form.defaultProps = {
  refreshData: () => {},
  resourceType: 'brandfolder',
  editableKey: null,
  selectedItem: null,
};

export default Form;
